<template>
  <campaigns-base variant="smart-tooltips" />
</template>

<script>
import CampaignsBase from '@/components/interactions/CampaignsBase.vue'

export default {
  name: 'SmartTooltipCampaigns',
  components: { CampaignsBase }
}
</script>
